import { render, staticRenderFns } from "./CustomGdprPopup.vue?vue&type=template&id=7afcc748&scoped=true&"
import script from "./CustomGdprPopup.vue?vue&type=script&lang=js&"
export * from "./CustomGdprPopup.vue?vue&type=script&lang=js&"
import style0 from "./CustomGdprPopup.vue?vue&type=style&index=0&id=7afcc748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afcc748",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Button.vue').default})
